module.exports = __webpack_public_path__ + "static/media/Lookema.9a4b65dc.jpg";